import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { ObservableService } from 'src/app/observable.service';
import { toVw, toVwU } from 'src/app/utils/ux';
import { gsap } from 'gsap';
import { IServiceRequest } from 'src/app/common/models/service-request.model';

declare let $: any;

@Component({
  selector: 'app-service-request',
  templateUrl: './service-request.component.html',
  styleUrls: ['./service-request.component.scss']
})
export class ServiceRequestComponent implements OnInit {

  @Input() serviceRequest: IServiceRequest;
  @Input() index: number;
  @Output() selectedCheque: EventEmitter<any> = new EventEmitter<any>();

  private actionOpned: boolean = false;
  private TASK_ITEM_SWIPE_DURATION = 0;
  private TASK_ITEM_SWIPE_LEFT_MAX = 0;
  private TASK_ITEM_SWIPE_RIGHT_MAX = 0;
  //private ACCOUNT_CARD_SWIPE_DISTANCE = 0;

  private ACTION_DIV_WIDTH_RIGHT = 78;
  private ACTION_DIV_WIDTH_LEFT = 0;

  private taskSwipeLeftAIs: any = [];
  private taskSwipeRightAIs: any = [];
  private taskSwipeStates: any = [];
  private taskSwipeIndexes: any = [];

  private selectedTaskIndex = -1;
  private swipedTaskIndex = -1;
  private playInProgress = false;

  private panHorizontalInProgress = false;
  private scrollerunlistener: () => void;

  private touchState = {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0
  };

  private taskTouchInProgress = false;
  private touchedTaskIndex = null;

  subcription: Subscription;

  constructor(private _observableService: ObservableService,
    private _renderer2: Renderer2,
    private changeDetectorRef: ChangeDetectorRef,) {

  }

  ngOnInit(): void {
    this.subcription = this._observableService.getTaskSwipeTrigger().subscribe((res) => {
      if (this.index != res && this.actionOpned) {
        if (this.taskSwipeRightAIs) this.taskSwipeRightAIs[this.index].reverse();
        if (this.taskSwipeLeftAIs) this.taskSwipeLeftAIs[this.index].reverse();
      }
    });
  }

  ngAfterViewInit() {
    this.teardownAnimations();
    this.setupAnimations();
  }

  ngOnDestroy() {
    if (this.scrollerunlistener) {
      this.scrollerunlistener();
    }
    document.body.removeEventListener("touchmove", this.documentTouchMoveHandler.bind(this), { capture: true });
    this.teardownAnimations();
  }

  calculateDimensions() {
    console.log("calculateDimensions", screen.width, screen.height, window.innerWidth, window.innerHeight);
    this.TASK_ITEM_SWIPE_LEFT_MAX = toVw(-this.ACTION_DIV_WIDTH_RIGHT);
    this.TASK_ITEM_SWIPE_RIGHT_MAX = toVw(this.ACTION_DIV_WIDTH_LEFT);
    //this.ACCOUNT_CARD_SWIPE_DISTANCE = toVw(160);
    this.TASK_ITEM_SWIPE_DURATION = 200 / 1000.0;

    console.log("calculateDimensions", this.TASK_ITEM_SWIPE_LEFT_MAX, this.TASK_ITEM_SWIPE_RIGHT_MAX, this.TASK_ITEM_SWIPE_DURATION);
  }

  teardownAnimations() {
    this.teardownCarouselAnimation();
  }

  teardownCarouselAnimation() {
    this.calculateDimensions();
    this.taskSwipeRightAIs.forEach((item) => {
      if (item) {
        item.kill();
        item = null;
      }
    });
    this.taskSwipeLeftAIs.forEach((item) => {
      if (item) {
        item.kill();
        item = null;
      }
    });
    if (this.scrollerunlistener) {
      this.scrollerunlistener();
    }
    document.body.removeEventListener("touchmove", this.documentTouchMoveHandler.bind(this), { capture: true });
  }

  setupAnimations() {
    this.setupCarouselAnimation();
  }

  setupCarouselAnimation() {
    this.taskSwipeLeftAIs = new Array();
    this.taskSwipeRightAIs = new Array();
    this.taskSwipeStates = new Array();

    let index = this.index;

    let target = "#serviceRequest_" + this.serviceRequest.requestReference + "_" + index;
    this.taskSwipeIndexes.push(index);

    let taskItemSwipeLeftAI = gsap.timeline({
      paused: true,
      duration: this.TASK_ITEM_SWIPE_DURATION,
      ease: "power1.in",
      smoothChildTiming: false,
    });
    taskItemSwipeLeftAI.eventCallback("onComplete", () => {
      console.log("onComplete taskItemSwipeLeftAI", index);
      this.actionOpned = true;
      $(target).addClass("open");
      this.taskSwipeStates[index] = -1;
      this.doResetPositions(index);
      this.doResetPlay();
    });
    taskItemSwipeLeftAI.eventCallback("onReverseComplete", () => {
      console.log("onReverseComplete taskItemSwipeLeftAI", index);
      this.actionOpned = false;
      $(target).removeClass("open");
      this.taskSwipeStates[index] = 0;
      this.doResetPlay();
    });

    taskItemSwipeLeftAI.fromTo(
      target + " .service-request-info",
      { css: { x: 0, paddingLeft: "24px", paddingRight: "24px" } },
      {
        css: { x: this.TASK_ITEM_SWIPE_LEFT_MAX, paddingLeft: "12px", paddingRight: "12px" }
      },
      0
    );

    taskItemSwipeLeftAI.fromTo(target + " .row-action-right", { css: { opacity: 0, width: toVwU(this.ACTION_DIV_WIDTH_RIGHT - 40) } }, { css: { opacity: 1, width: toVwU(this.ACTION_DIV_WIDTH_RIGHT) } }, 0);

    this.taskSwipeLeftAIs[index] = taskItemSwipeLeftAI;

    // let taskItemSwipeRightAI = gsap.timeline({
    //     paused: true,
    //     duration: this.TASK_ITEM_SWIPE_DURATION,
    //     ease: "power1.in",
    //     smoothChildTiming: false,
    // });
    // taskItemSwipeRightAI.eventCallback("onComplete", () => {
    //     this.actionOpned = true;
    //     $(target).addClass("open");
    //     this.taskSwipeStates[index] = 1;
    //     this.doResetPositions(index);
    //     this.doResetPlay();
    // });
    // taskItemSwipeRightAI.eventCallback("onReverseComplete", () => {
    //     this.actionOpned = false;
    //     $(target).removeClass("open");
    //     this.taskSwipeStates[index] = 0;
    //     this.doResetPlay();
    // });
    // taskItemSwipeRightAI.fromTo(
    //     target + " .cheque-info",
    //     { css: { x: 0, paddingLeft: "24px", paddingRight: "24px" } },
    //     {
    //         css: { x: this.TASK_ITEM_SWIPE_RIGHT_MAX, paddingLeft: "12px", paddingRight: "12px" }
    //     },
    //     0
    // );

    //taskItemSwipeRightAI.fromTo(target + " .row-action-left", { css: { opacity: 0, width: toVwU(this.ACTION_DIV_WIDTH_LEFT - 40) } }, { css: { opacity: 1, width: toVwU(this.ACTION_DIV_WIDTH_LEFT) } }, 0);
    //this.taskSwipeRightAIs[index] = taskItemSwipeRightAI;

    this.taskSwipeStates[index] = 0;

    this.scrollerunlistener = this._renderer2.listen(document.body, "scroll", this.documentScrollerHandler.bind(this));
    // document.body.addEventListener("touchmove", this.documentTouchMoveHandler.bind(this), { capture: true, passive: false });
    // document.body.addEventListener("touchend", this.documentTouchEndHandler.bind(this), { capture: true, passive: false });
  }

  doResetPositions(index) {
    this.taskSwipeIndexes.forEach((item_index, i) => {
      if (item_index != index) {
        if (this.taskSwipeStates[item_index] == -1) {
          this.taskSwipeLeftAIs[item_index].reverse();
          //this.seekSwipeLeftAnimation(item_index, 0);
        } else if (this.taskSwipeStates[item_index] == 1) {
          this.taskSwipeRightAIs[item_index].reverse();
          //this.seekSwipeRightAnimation(item_index, 0);
        }
        this.taskSwipeStates[item_index] = 0;
      }
    });
  }

  doResetPlay() {
    this.selectedTaskIndex = -1;
    this.playInProgress = false;
    this.changeDetectorRef.detectChanges();
  }

  swipeLeftHandler($event) {
    if (this.taskSwipeRightAIs || this.taskSwipeLeftAIs) {
      this._observableService.triggerTaskSwipe(this.index);
    }

    let index: number = this.index;
    console.log("Swipe Left", index, this.selectedTaskIndex, this.taskSwipeStates[index]);
    if (this.playInProgress) {
      console.log("Swipe Left Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    console.log("Swipe Left Accepted ");
    if (this.taskSwipeStates[index] == 1) {
      this.playInProgress = true;
      this.swipedTaskIndex = index;
      this.taskSwipeRightAIs[index].reverse();
    } else if (this.taskSwipeStates[index] == 0) {
      this.playInProgress = true;
      this.swipedTaskIndex = index;
      this.taskSwipeLeftAIs[index].play();
    }
  }

  swipeRightHandler($event) {
    if (this.taskSwipeRightAIs || this.taskSwipeLeftAIs) {
      this._observableService.triggerTaskSwipe(this.index);
    }

    let index: number = this.index;
    console.log("Swipe Right", index, this.selectedTaskIndex, this.taskSwipeStates[index]);
    if (this.playInProgress) {
      console.log("Swipe Right Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    console.log("Swipe Right Accepted");

    if (this.taskSwipeStates[index] == -1) {
      this.playInProgress = true;
      this.swipedTaskIndex = index;
      this.taskSwipeLeftAIs[index].reverse();
    } else if (this.taskSwipeStates[index] == 0) {
      this.playInProgress = true;
      this.swipedTaskIndex = index;
      //this.taskSwipeRightAIs[index].play();
    }
  }

  getAccountCardSwipeLeftProgress(deltaX) {
    let progress = Math.abs((deltaX / this.TASK_ITEM_SWIPE_LEFT_MAX) * 100);
    return Math.min(100, progress);
  }

  getAccountCardSwipeRightProgress(deltaX) {
    let progress = Math.abs((deltaX / this.TASK_ITEM_SWIPE_RIGHT_MAX) * 100);
    return Math.min(100, progress);
  }

  seekSwipeLeftAnimation(index, progress) {
    let seekTime = this.TASK_ITEM_SWIPE_DURATION * (progress / 100);
    console.log("Seek", progress, seekTime, this.taskSwipeStates[index]);
    let animeInstances = [];
    animeInstances.push(this.taskSwipeLeftAIs[index]);
    animeInstances.forEach((item) => {
      if (item) {
        item.pause().totalProgress(progress / 100.0);
      }
    });
  }

  seekSwipeRightAnimation(index, progress) {
    // let seekTime = this.TASK_ITEM_SWIPE_DURATION * (progress / 100);
    // console.log("Seek", progress, seekTime, this.taskSwipeStates[index]);
    // let animeInstances = [];
    // animeInstances.push(this.taskSwipeRightAIs[index]);
    // animeInstances.forEach((item) => {
    //     if (item) {
    //         item.pause().totalProgress(progress / 100.0);
    //     }
    // });
  }

  panStartHandler($event) {
    if (this.taskSwipeRightAIs || this.taskSwipeLeftAIs) {
      this._observableService.triggerTaskSwipe(this.index);
    }

    let index = this.index;
    console.log("Pan Start", index, this.selectedTaskIndex, $event.center.x);
    if (this.playInProgress) {
      console.log("Pan Start Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    let target = "#serviceRequest_" + this.serviceRequest.requestReference + "_" + index;
    this.actionOpned = false;
    $(target).removeClass("open");

    if (this.selectedTaskIndex == -1) {
      this.doResetPositions(index);
      this.playInProgress = false;
      this.selectedTaskIndex = index;
    }
  }

  panEndHandler($event) {
    let index = this.index;
    this.panHorizontalInProgress = false;
    console.log("Pan End", index, this.swipedTaskIndex, this.selectedTaskIndex, $event.deltaX);
    if (index == this.swipedTaskIndex) {
      this.swipedTaskIndex = -1;
      console.log("Pan End Skipped Pan End On Swipe Event");
      return;
    }

    if (this.swipedTaskIndex != -1 && this.playInProgress) {
      console.log("Pan End Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (index != this.selectedTaskIndex) {
      console.log("Pan End Index Not Eligible For Swipe");
      return;
    }

    if ($event.deltaX >= 0) {
      if (this.taskSwipeStates[index] == 0) {
        let progress = this.getAccountCardSwipeRightProgress($event.deltaX);
        console.log("Pan End Swipe Right", index, this.selectedTaskIndex, $event.deltaX, progress);
        if (progress > 50) {
          console.log("Pan End - Swipe Right 0 Play");
          this.playInProgress = true;
          // this.seekSwipeRightAnimation(index, progress);
          // this.taskSwipeRightAIs[index].play();
        } else {
          console.log("Pan End - Swipe Right 0 Reverse");
          this.playInProgress = true;
          //this.seekSwipeRightAnimation(index, progress);
          this.taskSwipeRightAIs[index].reverse();
        }
      }
      else if (this.taskSwipeStates[index] == -1) {
        let progress = this.getAccountCardSwipeLeftProgress($event.deltaX);
        console.log("Pan End Swipe Left", index, this.selectedTaskIndex, $event.deltaX, progress);
        if (progress > 50) {
          console.log("Pan End - Swipe Right -1 Reverse");
          this.playInProgress = true;
          //this.seekSwipeLeftAnimation(index, progress);
          this.taskSwipeLeftAIs[index].reverse();
        } else {
          console.log("Pan End - Swipe Right -1 Play");
          this.playInProgress = true;
          //this.seekSwipeLeftAnimation(index, progress);
          this.taskSwipeLeftAIs[index].play();
        }
      } else {
        console.log("Pan End - Swipe Right 1 Rejected");
        this.doResetPlay();
      }
    } else if ($event.deltaX < 0) {
      if (this.taskSwipeStates[index] == 0) {
        let progress = this.getAccountCardSwipeLeftProgress($event.deltaX);
        console.log("Pan End Swipe Left", index, this.selectedTaskIndex, $event.deltaX, progress);
        if (progress > 50) {
          console.log("Pan End - Swipe Left 0 Play");
          this.playInProgress = true;
          //this.seekSwipeLeftAnimation(index, progress);
          this.taskSwipeLeftAIs[index].play();
        } else {
          console.log("Pan End - Swipe Left 0 Reverse");
          this.playInProgress = true;
          //this.seekSwipeLeftAnimation(index, progress);
          this.taskSwipeLeftAIs[index].reverse();
        }
      } else if (this.taskSwipeStates[index] == 1) {
        let progress = this.getAccountCardSwipeRightProgress($event.deltaX);
        console.log("Pan End Swipe Right", index, this.selectedTaskIndex, $event.deltaX, progress);
        if (progress > 50) {
          console.log("Pan End - Swipe Right 1 Reverse");
          this.playInProgress = true;
          //this.seekSwipeRightAnimation(index, progress);
          this.taskSwipeRightAIs[index].reverse();
        } else {
          console.log("Pan End - Swipe Right 1 Play");
          this.playInProgress = true;
          // this.seekSwipeRightAnimation(index, progress);
          // this.taskSwipeRightAIs[index].play();
        }
      } else {
        console.log("Pan End - Swipe Left -1 Rejected");
        this.doResetPlay();
      }
    }
    if (this.playInProgress) {
      setTimeout(() => {
        this.doResetPlay();
      }, 300);
    }
  }

  panLeftHandler($event) {
    let index = this.index;
    let target = "#serviceRequest_" + this.serviceRequest.requestReference + "_" + index;
    let x: number = parseInt(gsap.getProperty(target + " .service-request-info", "x") + "");
    if (this.playInProgress) {
      //console.log("Pan Left Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (index == this.swipedTaskIndex) {
      //console.log("Pan Left Skipped - Pan Left On Swipe Event", index, this.swipedTaskIndex);
      return;
    }

    if (this.selectedTaskIndex == -1) {
      //console.log("Pan Left Skipped - No Selected Card", index);
      return;
    }

    this.panHorizontalInProgress = true;

    if ($event.deltaX > 0) {
      if (this.taskSwipeStates[index] == 0 || this.taskSwipeStates[index] == 1) {
        /*SWIPE RIGHT SEEK REVERSE*/
        let progress = this.getAccountCardSwipeRightProgress($event.deltaX);
        //console.log("Pan Left Swipe Right Seek Reverse", index, this.taskSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeRightAnimation(index, progress);
        }
      } else if (this.taskSwipeStates[index] == -1) {
        /*SWIPE LEFT SEEK REVERSE*/
        let progress = 100 - this.getAccountCardSwipeLeftProgress($event.deltaX);
        //console.log("Pan Left Swipe Left Seek Reverse", index, this.taskSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeLeftAnimation(index, progress);
        }
      }
    } else if ($event.deltaX < 0) {
      if (this.taskSwipeStates[index] == 0) {
        /*SWIPE LEFT SEEK PLAY*/
        let progress = this.getAccountCardSwipeLeftProgress($event.deltaX);
        //console.log("Pan Left Swipe Left Seek Play", index, this.taskSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeLeftAnimation(index, progress);
        }
      } else if (this.taskSwipeStates[index] == 1) {
        /*SWIPE RIGHT SEEK REVERSE*/
        let progress = 100 - this.getAccountCardSwipeRightProgress($event.deltaX);
        //console.log("Pan Left Swipe Right Seek Reverse", index, this.taskSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeRightAnimation(index, progress);
        }
      }
    }
  }

  panRightHandler($event) {
    let index = this.index;
    
    if (this.playInProgress) {
      console.log("Pan Right Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (index == this.swipedTaskIndex) {
      console.log("Pan Right Skipped - Pan Right On Swipe Event", index, this.swipedTaskIndex);
      return;
    }

    if (this.selectedTaskIndex == -1) {
      console.log("Pan Right Skipped - No Selected Card", index, this.selectedTaskIndex);
      return;
    }

    this.panHorizontalInProgress = true;

    if ($event.deltaX > 0) {
      if (this.taskSwipeStates[index] == 0) {
        /*SWIPE RIGHT SEEK*/
        // let progress = this.getAccountCardSwipeRightProgress($event.deltaX);
        // console.log("Pan Right Swipe Right Seek Play", index, this.taskSwipeStates[index], progress);
        // if (progress >= 0 && progress < 100) {
        //   this.seekSwipeRightAnimation(index, progress);
        // }
      } else if (this.taskSwipeStates[index] == -1) {
        /*SWIPE LEFT SEEK REVERSE*/
        let progress = 100 - this.getAccountCardSwipeLeftProgress($event.deltaX);
        console.log("Pan Right Swipe Left Seek Reverse", index, this.taskSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeLeftAnimation(index, progress);
        }
      }
    } else if ($event.deltaX < 0) {
      if (this.taskSwipeStates[index] == 0 || this.taskSwipeStates[index] == -1) {
        /*SWIPE LEFT SEEK PLAY*/
        let progress = this.getAccountCardSwipeLeftProgress($event.deltaX);
        console.log("Pan Right Swipe Left Seek Play", index, this.taskSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeLeftAnimation(index, progress);
        }
      } else if (this.taskSwipeStates[index] == 1) {
        /*SWIPE RIGHT SEEK REVERSE*/
        // let progress = 100 - this.getAccountCardSwipeRightProgress($event.deltaX);
        // console.log("Pan Right Swipe Right Seek Reverse", index, this.taskSwipeStates[index], progress);
        // if (progress > 0 && progress < 100) {
        //   this.seekSwipeRightAnimation(index, progress);
        // }
      }
    }
  }

  documentTouchMoveHandler($event) {
    this.touchState.y2 = $event.changedTouches && $event.changedTouches[0].clientY;
    this.touchState.x2 = $event.changedTouches && $event.changedTouches[0].clientX;
    let angle = 90;
    if (this.touchState.x2 != this.touchState.x1) {
      angle = Math.atan(Math.abs(this.touchState.y2 - this.touchState.y1) / Math.abs(this.touchState.x2 - this.touchState.x1)) * 57.32;
    }

    if (this.panHorizontalInProgress) {
      //console.log("Touch End", this.touchedTaskIndex, this.taskSwipeStates[this.touchedTaskIndex], angle);      
      //console.log("Cancel Pan In Progress Card", $event.cancelable);
      if ($event.cancelable) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    } else if (this.taskTouchInProgress) {
      //console.log("Touch Move", this.touchedTaskIndex, this.taskSwipeStates[this.touchedTaskIndex], angle);
      if (this.taskSwipeStates[this.touchedTaskIndex] != 0) {
        //console.log("Cancel Move Open Card", $event.cancelable);
        if ($event.cancelable) {
          $event.preventDefault();
          $event.stopPropagation();
        }
      }
    }
  }

  documentTouchEndHandler($event) {
    this.touchState.y2 = $event.changedTouches && $event.changedTouches[0].clientY;
    this.touchState.x2 = $event.changedTouches && $event.changedTouches[0].clientX;
    let angle = 90;
    if (this.touchState.x2 != this.touchState.x1) {
      angle = Math.atan(Math.abs(this.touchState.y2 - this.touchState.y1) / Math.abs(this.touchState.x2 - this.touchState.x1)) * 57.32;
    }

    if (this.panHorizontalInProgress) {
      console.log("Touch End", this.touchedTaskIndex, this.taskSwipeStates[this.touchedTaskIndex], angle);
      console.log("Cancel Pan In Progress Card", $event.cancelable);
      if ($event.cancelable) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    } else if (this.taskTouchInProgress) {
      console.log("Touch End", this.touchedTaskIndex, this.taskSwipeStates[this.touchedTaskIndex], angle);
      if (this.taskSwipeStates[this.touchedTaskIndex] != 0) {
        console.log("Cancel End Open Card", $event.cancelable);
        if ($event.cancelable) {
          $event.preventDefault();
          $event.stopPropagation();
        }
      }
    }
    this.taskTouchInProgress = false;
    this.touchedTaskIndex = null;
  }

  documentScrollerHandler($event) {
    //console.log("documentScrollerHandler");
    this.doResetPositions(-1);
  }

  touchStartHandler($event) {
    let index = this.index;
    console.log("Touch Start", index);
    this.taskTouchInProgress = true;
    this.touchedTaskIndex = index;
    this.touchState.y1 = $event.changedTouches && $event.changedTouches[0].clientY;
    this.touchState.x1 = $event.changedTouches && $event.changedTouches[0].clientX;
  }
  emitItemDetails(details) {
    this.selectedCheque.emit(details);
  }

}
